module.exports = __webpack_public_path__ + "img/gg_01.9e6f2fb8.jpg";